import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import File from '@root/views/File/File';
import FraseIcon from '@root/assets/Frase_icon.png';
import FraseDrawer from '@root/components/integrations/Frase/components/FraseDrawer';
import SimpleTooltip from '@root/components/tooltips/SimpleTooltip';

const useStyles = makeStyles(() => ({
  frase: {
    height: 32,
    width: 32,
    '&:hover': {
      color: 0.5,
    },
  },
  frasePaperStyle: {
    minWidth: '30vw',
    width: '30vw',
    height: '75vh',
    padding: '32px',
    borderRadius: '12px',
    margin: '58px 0px 0px 24px',
    position: 'sticky',
    top: 109,
  },
}));

const documentControls = ['selectAll', 'example', 'plagiarismCheck', 'contentExpander', 'contentRewriter', 'frase', 'export', 'settings'];

const BlogPostGenerator = () => {
  const params = useParams();
  const classes = useStyles();

  return (
    <File
      id={params.id}
      templateType="blogPost"
      engineChoiceEnabled={false}
      includeBlogCredits
      includeCreditsRight={false}
      mapGenerateButtonProps={(fileData) => ({
        blogCreditDecrementAmount: fileData.numberOfBlogPosts,
        numOriginalContent: '2',
        isBlogGenerator: true,
      })}
      loadingTime="1.5 minutes"
      documentControls={documentControls}
      integration={{
        renderPanelComponent: ({ toggleIntegration }, currentUser) => {
          return currentUser.permissions.frase && (
            <SimpleTooltip
              content="Optimize your Blog SEO and identify top keywords"
              placement="bottom"
            >
              <span>
                <img
                  className={classes.frase}
                  alt="FraseDrawer"
                  onClick={toggleIntegration}
                  src={FraseIcon}
                  role="presentation"
                />
              </span>
            </SimpleTooltip>
          );
        },
        renderSideComponent: ({
          toggleIntegration,
          highlightedDocumentIndex,
          setHighlightedDocumentIndex,
          documents,
          integrationOpen,
        }) => documents.length > 0 && integrationOpen && (
          <Paper className={classes.frasePaperStyle}>
            <FraseDrawer
              selectedGen={highlightedDocumentIndex}
              setSelectedGen={setHighlightedDocumentIndex}
              generation={documents}
              setDrawerState={toggleIntegration}
            />
          </Paper>
        ),
      }}
      maxRewriteLength={400}
    />
  );
};

export default BlogPostGenerator;
